import { filter } from 'lodash';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  IconButton,
  Typography,
  Backdrop,
  CircularProgress,
  Stack,
  Button,
  styled
} from '@material-ui/core';

import moment from 'moment';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import CreateIcon from '@material-ui/icons/Create';
import { baseUrl } from '../../utils/constants';
import Scrollbar from '../Scrollbar';
import SearchNotFound from '../SearchNotFound';
import { useClaimsContext } from '../../context/claims_context';
import { ClientListHead } from '../_dashboard/clients';
import Controls from '../controls/Controls';

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));

const TABLE_HEAD = [
  { id: 'billNo', label: 'Run #', alignRight: true },
  { id: 'billDate', label: 'Date', alignRight: false },
  { id: 'description', label: 'Description', alignRight: false },
  { id: 'revenue', label: 'Revenue', alignRight: false },
  { id: 'cycle', label: 'Cycle', alignRight: false },
  { id: 'creaetd', label: 'Created', alignRight: true },
  { id: 'posted', label: 'Posted', alignRight: true },
  { id: 'as', label: '' },
  { id: 'asd', label: '' }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_doc) => _doc.documentType.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function SelectBill() {
  const { setBatchNo, clearBatch, setCurrentBatch } = useClaimsContext();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [orderBy, setOrderBy] = useState('documentType');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: '#000000'
  });
  const navigate = useNavigate();

  useEffect(() => {
    GetCycleBills();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const GetCycleBills = async () => {
    setLoading(true);
    await axios(`${baseUrl}/api/accounting/GetCycleBills`).then(
      (res) => {
        setLoading(false);
        console.log('returned GetTermBills', res);
        setDataList(res.data.result);
      },
      (error) => {
        setLoading(false);
        alert(`failed here ${{ error }}`);
      }
    );
  };

  const handleBatchDelete = async (e) => {
    console.log('e here', e.batchID);
    if (e === '') {
      return;
    }
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });
    setLoading(true);
    await axios.post(`${baseUrl}/api/claims/deleteBatch?batchId=${e.batchID}`).then(
      (result) => {
        setLoading(false);
        if (result.replyStatus === 1) {
          notifyPopup(`Error in Deleting Batch!: ${result.replyMessage}`, 'error');
        } else {
          notifyPopup(`Batch Deleted Successfully!`, 'success');
          navigate(-1);
        }
      },
      (error) => {
        notifyPopup(`Error in Deleting Batch!: ${error}`, 'error');
      }
    );
  };

  const handleEditView = (e) => {
    openEdit(e.row.refId);
  };

  const openNew = () => {
    // clearBatch();
    navigate(`/accounts/bill/0`);
  };

  const openEdit = (e) => {
    console.log('e right', e);
    navigate(`/accounts/bill/${e}`);
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataList.length) : 0;

  const filteredUsers = applySortFilter(dataList, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  return (
    <Container>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb="10">
        <Typography component="span" variant="h6" gutterBottom>
          Subscriptions Billing
        </Typography>
        <Button
          type="button"
          variant="outlined"
          color="secondary"
          startIcon={<NoteAddIcon />}
          onClick={() => openNew()}
        >
          Create Bill
        </Button>
      </Stack>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Card>
        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table size="small" aria-label="a dense table">
              <ClientListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={dataList.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    /* eslint-disable camelcase */
                    const {
                      refId,
                      billDate,
                      billPrinted,
                      description,
                      cycle,
                      revenue,
                      created,
                      posted
                    } = row;
                    const isItemSelected = selected.indexOf(refId) !== -1;

                    return (
                      <StyledTableRow
                        hover
                        key={refId}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox" />
                        <TableCell align="right">{refId}</TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          {moment(billDate).isValid() ? moment(billDate).format('YYYY-MM-DD') : ''}
                        </TableCell>
                        <TableCell align="left">{description}</TableCell>
                        <TableCell align="left">{revenue}</TableCell>
                        <TableCell align="left">{cycle}</TableCell>
                        <TableCell align="right">{created ? 'Yes' : 'No'}</TableCell>
                        <TableCell align="right">{posted ? 'Yes' : 'No'}</TableCell>
                        <TableCell align="right">
                          <IconButton onClick={() => handleEditView({ row })}>
                            <CreateIcon sx={{ color: '#03a9f4' }} />
                          </IconButton>
                        </TableCell>
                        {/* <TableCell align="right">
                          {batchStatus_Id < 3 && (
                            <IconButton
                              onClick={() =>
                                setConfirmDialog({
                                  isOpen: true,
                                  title: 'Are you sure you want to Delete Batch',
                                  subTitle: "You can't undo this action",
                                  heading: 'Delete Batch',
                                  color: '#00000',
                                  onConfirm: () => {
                                    handleBatchDelete({ batchID });
                                  }
                                })
                              }
                            >
                              <DeleteForeverIcon sx={{ color: '#f44336' }} />
                            </IconButton>
                          )}
                        </TableCell> */}
                      </StyledTableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <Controls.Notification notify={notify} setNotify={setNotify} />
          <Controls.ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
        </Scrollbar>

        <TablePagination
          sx={{
            backgroundColor: 'black',
            color: 'white',
            size: 'small'
          }}
          rowsPerPageOptions={[8, 16, 24]}
          component="div"
          count={dataList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>
  );
}
